import { Component, OnInit, Input } from '@angular/core';
import { SearchMatch } from 'src/app/models/searchMatch';

@Component({
  selector: 'app-search-matches',
  templateUrl: './search-matches.component.html',
  styleUrls: ['./search-matches.component.css']
})
export class SearchMatchesComponent implements OnInit {
  @Input() matches: SearchMatch[]

  constructor() { }

  ngOnInit() {
  }

}
